import { defineStore } from 'pinia';

export const useBottomNavStore = defineStore('bottomNav', {
  state: () => ({
    showNav: true
  }),
  actions: {
    toggleNav(show = null) {
      this.showNav =  show !== null ? show : !this.showNav;
    }
  }
});
